import React, { ReactElement } from 'react';
import { Flex, Stack } from '@grubhubprod/gh-cookbook-react/dist';

export interface SignupStepFooterActionsPhoneProps {
  back?: ReactElement;
  skip?: ReactElement;
  next: ReactElement;
}

export function SignupStepFooterActionsPhone({
  back,
  skip,
  next,
}: SignupStepFooterActionsPhoneProps): JSX.Element {
  // On mobile, Skip takes priority over Back.
  const leftButton = skip ?? back;

  if (!leftButton) {
    return <Flex width="100%">{next}</Flex>;
  }

  return (
    <Flex width="100%">
      <Stack x="x-sm" flex="1">
        {leftButton}
      </Stack>
      <Flex flex="1">{next}</Flex>
    </Flex>
  );
}
